// service
import AxiosInstanceCreator from 'services/api';

// libraries
import { type AxiosInstance } from 'axios';

export class TextAPI {
  Axios: AxiosInstance;

  constructor() {
    this.Axios = new AxiosInstanceCreator().create();
  }

  /** 약관 기본 텍스트 조회 API */
  async getText(): Promise<string> {
    return await this.Axios.get<string>('/text').then((res) => res.data);
  }

  /** 이용약관 텍스트 조회 API */
  async getTerms(): Promise<string> {
    const res = await fetch('/policy/terms.html');
    return await res.text();
  }

  /** 개인정보처리방침 텍스트 조회 API */
  async getPrivacy(): Promise<string> {
    const res = await fetch('/policy/privacy.html');
    return await res.text();
  }
}
